export default __webpack_public_path__ + "static/media/uniqueGhost.b3aa8372.png";